import type { PDFDocumentProxy } from 'pdfjs-dist'
import * as pdfjs from 'pdfjs-dist'
import workerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl

export type { PDFDocumentProxy, PDFPageProxy } from 'pdfjs-dist'
export { pdfjs }

const base = import.meta.env.BASE_URL

export class PasswordRequiredError extends Error {
  constructor(public readonly incorrect: boolean) {
    super(incorrect ? 'Incorrect password' : 'Password required')
  }
}

/**
 * Open a PDF with pdf.js. pdf.js transfers the buffer to its worker, so we always pass a copy
 * and keep the original bytes for export.
 */
export async function openPdf(bytes: Uint8Array, password?: string): Promise<PDFDocumentProxy> {
  const task = pdfjs.getDocument({
    data: bytes.slice(),
    password,
    cMapUrl: `${base}pdfjs/cmaps/`,
    cMapPacked: true,
    standardFontDataUrl: `${base}pdfjs/standard_fonts/`,
    wasmUrl: `${base}pdfjs/wasm/`,
    iccUrl: `${base}pdfjs/iccs/`,
    enableXfa: false,
  })
  return new Promise<PDFDocumentProxy>((resolve, reject) => {
    task.onPassword = (_update: unknown, reason: number) => {
      // reason 2 = INCORRECT_PASSWORD, 1 = NEED_PASSWORD
      task.destroy()
      reject(new PasswordRequiredError(reason === pdfjs.PasswordResponses.INCORRECT_PASSWORD))
    }
    task.promise.then(resolve, reject)
  })
}

export function isPdf(bytes: Uint8Array) {
  // %PDF- may be preceded by junk bytes in the first 1024 bytes
  const head = new TextDecoder('latin1').decode(bytes.subarray(0, 1024))
  return head.includes('%PDF-')
}
